const consentTypes = {
    MANDATORY: 'MANDATORY',
    NOT_MANDATORY: 'NOT_MANDATORY',
};

export default consentTypes;
